import styled, { css } from 'styled-components';
import { zIndex } from 'styles';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { SPACING_16, SPACING_24, SPACING_8 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';
import { RADIUS_2 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/border-radius';
import { DEEP_BORDER_BOX } from 'common';

/* Defaults */
const BALLON_SIZE = 2.25;

export const Coachmarks = styled.div``;
export const CoachmarkTitle = styled.h3`
  flex-grow: 1;
  margin: 0;
`;

export const CoachmarkBalloon = styled.div`
  position: absolute;
  height: ${BALLON_SIZE}rem;
  width: ${BALLON_SIZE}rem;
  &:before {
    content: '';
    position: absolute;
    border-color: ${Tokens.COLORS.TRANSPARENT};
    border-style: solid;
    z-index: -1;
  }
  &[data-popper-placement^='top'] {
    bottom: 0;
    :before {
      bottom: -${BALLON_SIZE / 2}rem;
      left: -${BALLON_SIZE / 2}rem;
      border-width: ${BALLON_SIZE / 2}rem ${BALLON_SIZE / 2}rem 0;
      border-top-color: ${({ $elevationStyles }) => $elevationStyles && $elevationStyles.backgroundColor};
      transform-origin: center top;
    }
  }

  &[data-popper-placement^='bottom'] {
    top: 0;
    :before {
      top: -${BALLON_SIZE / 2}rem;
      left: -${BALLON_SIZE / 2}rem;
      border-width: 0 ${BALLON_SIZE / 2}rem ${BALLON_SIZE / 2}rem;
      border-bottom-color: ${({ $elevationStyles }) => $elevationStyles && $elevationStyles.backgroundColor};
      transform-origin: center bottom;
    }
  }

  &[data-popper-placement^='left'] {
    right: 0;
    top: 0;
    :before {
      border-width: ${BALLON_SIZE / 2}rem 0 ${BALLON_SIZE / 2}rem ${BALLON_SIZE / 2}rem;
      border-left-color: ${({ $elevationStyles }) => $elevationStyles && $elevationStyles.backgroundColor};
      right: -${BALLON_SIZE / 2}rem;
      transform: translateY(0rem);
      transform-origin: center left;
    }
  }

  &[data-popper-placement^='right'] {
    left: 0;
    top: 0;
    :before {
      left: -${BALLON_SIZE / 2}rem;
      border-width: ${BALLON_SIZE / 2}rem ${BALLON_SIZE / 2}rem ${BALLON_SIZE / 2}rem 0;
      border-right-color: ${({ $elevationStyles }) => $elevationStyles && $elevationStyles.backgroundColor};
      transform-origin: center right;

      transform: translateY(0rem);
    }
  }
`;

export const CoachmarkAnimation = styled.div`
  -webkit-font-smoothing: antialiased;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  will-change: transform;
  transform: translate3d(0, 0, 0);

  &[data-popper-placement^='bottom'] {
    transform-origin: top;
  }
  &[data-popper-placement^='top'] {
    transform-origin: bottom;
  }
  &[data-popper-placement^='left'] {
    transform-origin: top right;
  }
  &[data-popper-placement^='right'] {
    transform-origin: top left;
  }

`;

export const CoachmarkContent = styled.div`
  padding: ${SPACING_24};
  color: ${({ $theme }) => $theme && $theme.content};
`;

export const CoachmarkFooter = styled.div`
  display: flex;
  padding: ${SPACING_16}; /** NOTE: Specs say SPACING_24 but that doesn't reflect the screenshots */
  justify-content: flex-end;
  ${props =>
    props.$border &&
    css`
      border-top: 1px solid rgba(0, 0, 0, .12);
    `};
`;

export const CoachmarkHeader = styled.div`
  display: flex;
  align-items: center;
  padding: ${SPACING_16} ${SPACING_24};
  padding-bottom: 0;
`;

export const CoachmarkCount = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin: 0 ${SPACING_8};
  color: ${({ $theme }) => $theme && $theme.count};
`;

export const CoachmarkContainer = styled.div`
  position: relative;
  ${({ $rtl }) =>
    css`
      direction: ${$rtl ? 'rtl' : 'ltr'};
    `}
  ${({ $global }) =>
    $global &&
    css`
      position: fixed;
      top: 50vh;
      left: 50vw;
      transform: translate(-50%, -50%);
    `}
    /** for it to be lower than dialog (dialog is set to 30) 
      but also it needs to be higher than app-banner
    */
  z-index: ${zIndex.COACHMARKS};
`;

export const Coachmark = styled.div`
  border-radius: ${RADIUS_2};
  outline: none;
  will-change: transform;
`;

export const CoachmarkOverlay = styled.div`
  ${DEEP_BORDER_BOX}  
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background: ${Tokens.COLORS.TRANSPARENT};
  ${({ $overlay }) =>
    $overlay &&
    css`
      background: ${$overlay.backgroundColor};
    `}
`;

export const CoachmarkButtonRow = styled.div`
  [class^='styles__ButtonsRow-'] {
    padding: 0;
  }
`;

export const CoachmarkCloseButton = styled.div`
`;

export default {
  Coachmarks,
  CoachmarkContainer,
  Coachmark,
  CoachmarkBalloon,
  CoachmarkTitle,
  CoachmarkHeader,
  CoachmarkContent,
  CoachmarkFooter,
  CoachmarkCount,
  CoachmarkAnimation,
  CoachmarkOverlay,
  CoachmarkCloseButton,
  CoachmarkButtonRow
};
